import {
  ConversationErrorCode,
  ConversationStatus,
  SourcedCandidateStatus
} from 'generated-graphql/types';
import React from 'react';
import { IconTooltip } from 'common/ui';
import { Error } from '@mui/icons-material';
import { Loading } from 'common/ui/Loading';
import { getStatusConfig } from 'modules/conversations/components';

type Props = {
  conversationStatus: ConversationStatus;
  sourcedCandidateStatus: SourcedCandidateStatus;
  needsReview: boolean;
  conversationId?: string | null;
  errorCode?: ConversationErrorCode | null;
};

export const SourcingConversationStatusIcon: React.FC<Props> = ({
  conversationStatus,
  needsReview,
  sourcedCandidateStatus,
  conversationId,
  errorCode
}) => {
  if (!conversationId) {
    if (
      sourcedCandidateStatus === SourcedCandidateStatus.Duplicate ||
      sourcedCandidateStatus === SourcedCandidateStatus.EnrichmentFailed
    ) {
      return (
        <IconTooltip title="Not delivered. Check contact details">
          <Error
            sx={{
              fontSize: '20px',
              color: 'error.main'
            }}
          />
        </IconTooltip>
      );
    }

    return <Loading size={20} />;
  }
  const config = getStatusConfig(
    conversationStatus,
    needsReview,
    null,
    errorCode
  );
  if (!config) return <div />;

  return <IconTooltip title={config.tooltipTitle}>{config.icon()}</IconTooltip>;
};
